'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('RegisterfaultFormCtrl', ['$scope', '$sce', '$filter', '$http', '$log', 'ajaxSearch', function ($scope, $sce, $filter, $http, $log, ajaxSearch) {


	$scope.forms = jsRegisterFault.forms;
	$scope.default_questions = jsRegisterFault.questions;
	$scope.questions = jsRegisterFault.questions;
	$scope.questions_svyruoja = jsRegisterFault.questions_svyruoja;
	$scope.questions_el_saitiklio = jsRegisterFault.questions_el_saitiklio;
	$scope.getIconPath = function (form) {
		if (form.image) {
			return form.image;
		}
		return form.icon2;
	};

	$scope.findUrl = jsRegisterFault.findUrl;
	$scope.postUrl = jsRegisterFault.submitUrl;//jsRegisterFault.submitUrl

	$scope.trySubmit = false;
	$scope.loading = false;
	$scope.submited = false;
	$scope.messages = [];
	$scope.addresses = [];
	$scope.showSuggest = false;

	$scope.phoneNumberPattern = /^(\+*)[0-9\s]{9,14}$/;
	$scope.phoneNumberPatternInt = /^\d{7}$/;
	$scope.emailPattern = /^.+@[^@;!`~#$%\^&*\(\)=+]{2,}\.[a-z]{2,6}$/;
	$scope.housePattern = /^[0-9]/;

	function getDefaultData() {
		return {
			recaptchaResponse: null,
			address: '',
			address_id: null,
			house: '',
			appartment: '',
			phone: '',
			email: '',
			comment: '',
			category: ''
		};
	}
	$scope.formData = getDefaultData();

	$scope.displayStatus = 0;
	$scope.id = 0;
	$scope.allAnswersRendered = false;
	$scope.progressVal = 0;
	$scope.displayProgress = false;
	$scope.resultsPage = false;
	$scope.situation_title = '';
//	$scope.number_bad_searches = 0;
//	$scope.limit_bad_searches = 3;
	$scope.bad_address_length = 5;
	$scope.show_bad_searches = false;
	$scope.back_to_question = false;
	$scope.back_question_id = null;
	$scope.embedType = '';
	$scope.embedTid;


	$scope.urlParams = {
		forma: '',
		klausimas: [],
		kategorija: ''
	};

	var searchObj = {};
	var queryString = '';


	function parseSearch(){
		queryString = window.location.search;
		let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('_');
		for (var i = 0; i < pairs.length; i++) {
			let pair = pairs[i].split('-');
			let name = decodeURIComponent(pair[0]);
			searchObj[name] = decodeURIComponent(pair[1] || '');
			if(name === 'klausimas'){
				searchObj[name] = searchObj[name].split(',');
			}
		}
	}
	parseSearch();

	function setQueryData(){
		queryString = '?' + formatHistoryQuery();
		history.pushState("", document.title, window.location.pathname + queryString);
	}

	function formatHistoryQuery(){
		let el = [];
		for(var i in $scope.urlParams){
			if(i==='klausimas'){
				if($scope.urlParams['klausimas'].length>0){
					el.push(i+'-'+$scope.urlParams['klausimas'].join(','));
				}
			}
			else if(typeof($scope.urlParams[i])!=='undefined' && $scope.urlParams[i] !==''){
				el.push(i+'-'+$scope.urlParams[i]);
			}
		}
		if($scope.urlParams.forma ==='neraelektros'){
			$scope.embedTid = 4;
		}
		else if($scope.urlParams.forma ==='nerafazes'){
			$scope.embedTid = 5;
		}
		else{
			$scope.embedTid = '';
		}

		return el.join('_');
	}

	$scope.spliceQuestionId = function(question_id){
		let indx = $scope.urlParams.klausimas.indexOf(question_id);

		if(indx>-1){
			$scope.urlParams.klausimas.splice(indx, 1);
			setQueryData();
		}
//		console.log($scope.urlParams.questions)
	};

	$scope.addQuestion = function(question_id){
		let indx = $scope.urlParams.klausimas.indexOf(question_id);
		if(question_id === 1){
			$scope.embedType = 'B';
		}
		if(question_id === 50){
			$scope.embedType = 'N';
		}
		if(indx===-1){
			$scope.urlParams.klausimas.push(question_id);
			setQueryData();
		}
//		console.log($scope.urlParams)
	};

	$scope.$watch("urlParams.forma", function(){
//		console.log('change');
		setQueryData();
	});


	var $cont = $('.main-content');
	var $header = $('.header-container');

	$scope.setDisplayStatus = function (status) {
        let category_id = '';
        if(arguments[1]){
            category_id = arguments[1];
        }
//		console.log(category_id)
		document.querySelector('.index_container').scrollIntoView({
			behavior: 'smooth'
		});
			if (status > 0 && category_id != '') {
				let title = jsRegisterFault.forms[category_id].title;
				$scope.situation_title = $sce.trustAsHtml(title);
			} else if (status == 0) {
				$scope.situation_title = '';
			}
		if (status == 0) {
			$scope.situation_title = '';
			$scope.formData.itampos_kokybes_text = '';
			$scope.urlParams = {
				forma: '',
				klausimas: []
			};
		}
		$scope.displayStatus = status;
		$scope.setdisplayProgress(true);
		if (category_id != '') {
			$scope.urlParams.forma = category_id;
			$scope.formData.category = category_id;
			$scope.formParams = jsRegisterFault.forms[$scope.formData.category];
			if ($scope.formData.category == 'pavojingamano' || $scope.formData.category == 'pavojinganemano' || $scope.formData.category == 'kita') {
				$scope.displayStatus = 99;
				$scope.setdisplayProgress(false);
				$scope.progressVal = '100';
			}
			if ($scope.formData.category == 'svyruojaitampa') {
				$scope.questions = $scope.questions_svyruoja;
			}
			if ($scope.formData.category == 'elektrosskaitiklio') {
				$scope.questions = $scope.questions_el_saitiklio;
			}
	}
	/*if ( status == 1 ){
	 fixView();
	 }*/
	};
	$scope.setdisplayProgress = function (val) {
		$scope.displayProgress = val;
	};

	$scope.stepBack = function (btn) {
		if (btn.back_id >= 0) {
			btn.question_id = btn.back_id;
			if (typeof btn.back_question_id !== 'undefined' && btn.back_question_id > 0) {
				btn.question_id = btn.back_question_id;
				btn.back_question_id = null;
			}
//			console.log(btn.id)
			$scope.spliceQuestionId(btn.id);
			$scope.getCurrentQuestions(btn);
		} else {
			$scope.questions = $scope.default_questions;
			$scope.setDisplayStatus(0);
		}
	};

	$scope.backToQuestion = function (question_id) {
		if($scope.displayStatus === 99){
			$scope.spliceQuestionId(99);
		}
		$scope.displayStatus = 1;
		$scope.submited = false;
		for (var i = 0, len = $scope.questions.length; i < len; i++) {
			if ($scope.questions[i].id == question_id) {
				$scope.id = question_id;
				$scope.questions[i].back_question_id = question_id;
				$scope.stepBack($scope.questions[i]);
				break;
			}
		}
	};

	$scope.backToStart = function () {
		$scope.situation_title = '';
		$scope.questions = $scope.default_questions;
		$scope.setDisplayStatus(0);
		$scope.id = 0;
		$scope.progressVal = 0;
		$scope.submited = false;
		$scope.formData = getDefaultData();
		$scope.back_to_question = false;
	};

	$scope.getCurrentQuestions = function (btn) {
//		console.log(btn)
		showResults(btn);
		if(btn.question_id>0){
			$scope.addQuestion(btn.question_id);
		}
		if(typeof(btn.category) !== 'undefined'){
			$scope.formData.category = btn.category;
			if(btn.category === 'svyruojaitampa_0' || btn.category === 'elektrosskaitiklio_0'){
				$scope.urlParams.kategorija = '0';
			}
			if(btn.category === 'svyruojaitampa_1' || btn.category === 'elektrosskaitiklio_1'){
				$scope.urlParams.kategorija = '1';
			}
			setQueryData();
		}
		if(typeof(btn.itampos_kokybes_text) !== 'undefined'){
			$scope.formData.itampos_kokybes_text = btn.itampos_kokybes_text;
		}
	};

	var showResults = function (btn) {
		for (var i = 0, len = $scope.questions.length; i < len; i++) {
			if ($scope.questions[i].id == btn.question_id) {
				$scope.id = i;
				$scope.progressVal = $scope.questions[i].progress;
				break;
			}
		}

		//show list
		if (btn.question_id == 99) {
			if (typeof btn.back_question_id !== 'undefined' && btn.back_question_id > 0) {
				$scope.back_to_question = true;
				$scope.back_question_id = btn.back_question_id;
			} else {
				$scope.loading = false;
				$scope.resultsPage = true;
			}
			$scope.setDisplayStatus(btn.question_id);
		}
		fixView();
	};

	var fixView = function () {
		if ($cont.offset().top < $(window).scrollTop()) {
			$('html, body').animate({
				scrollTop: $cont.offset().top - $header.outerHeight(true) - 20
			}, 250);
		}
	};

	$scope.findAddress = function () {
		$scope.formData.address_id = null;
		if ($scope.findUrl !== '' && $scope.formData.address != '') {

			$scope.loading = true;
			$scope.show_bad_searches = false;
			$scope.clearAddressSugggests();

			ajaxSearch.search($scope.findUrl, {address: $scope.formData.address}).then(function (response) {
				if (response.success) {
					$scope.addresses = response.items;
					if ($scope.addresses.length > 0) {
						$scope.showSuggest = true;
						$scope.show_bad_searches = false;
					} else {
						$scope.addresses = [];
						$scope.messages = response.messages;
						/*$scope.number_bad_searches += 1;
						 if ($scope.number_bad_searches >= $scope.limit_bad_searches) {
						 $scope.show_bad_searches = true;
						 }*/
						if ($scope.formData.address != '' && $scope.formData.address.length >= $scope.bad_address_length) {
							$scope.show_bad_searches = true;
						}
					}
					$scope.loading = false;
				}
			}, function (response) {
				$log.error(response);
			});
		} else {
			$scope.clearAddressSugggests();
		}
	};

	$scope.setAddress = function (address) {
		$scope.formData.address_id = address._source.adr_id;
		$scope.formData.address = address._source.adr_sudetinis_adresas;
		$scope.formData.house = address._source.adr_vieta;
		$scope.formData.appartment = address._source.adr_patalpos_numeris;
		$scope.clearAddressSugggests();
	};

	$scope.clearAddressSugggests = function () {
		$scope.showSuggest = false;
		$scope.addresses = [];
		$scope.messages = [];
	};

	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	}

//	$scope.isSetMandatoryAddress = function () {
//		if ($scope.formData.address === '' || $scope.formData.address_id === '') {
//			return false;
//		}
//		return true;
//	};
	$scope.isSetMandatoryAddress = function () {
		if ($scope.formParams.fields.address.active && $scope.formParams.fields.address.mandatory && (!$scope.formData.address_id || $scope.formData.address_id === '')) {
			return false;
		}
		return true;
	};

	$scope.isValid = function () {
		if (!$scope.isSetMandatoryAddress()) {
			return false;
		}
		return true;
	};

	$scope.submitForm = function (form) {
		$scope.trySubmit = true;
		if ($scope.isValid() && $scope.postUrl && $scope.postUrl !== '') {
			$scope.loading = true;
			if(typeof jsRegisterFault.recaptcha !== 'undefined'){
				grecaptcha.ready(function() {
					grecaptcha.execute(jsRegisterFault.recaptcha.siteKey, {action: 'submit'}).then(function(token){
						$scope.formData.recaptchaResponse = token;
						$scope.submitFormPost(form);
					});
				});
			}
			else{
				$scope.submitFormPost(form);
			}
		} else {
			form.$submitted = false;
		}
	};

	$scope.submitFormPost = function (form) {
		$scope.messages = [];
		$scope.responseFalse = false;
		$http({
			method: 'POST',
			url: $scope.postUrl,
			data: getPostData()
		}).then(function (response) {
			if (response.data.success) {
				$scope.submited = true;
				form.$setPristine();
				form.$setUntouched();
				form.$submitted = false;
				fixView();
			} else {
				form.$submitted = false;
				$scope.responseFalse = true;
				if (typeof response.data.errors !== 'undefined' && response.data.errors.length > 0) {
					$scope.messages = response.data.errors;
				}
			}
		}).then(function () {
			$scope.loading = false;
		});
	};

	function getPostData() {
		var data = {};
		if(typeof jsRegisterFault.recaptcha !== 'undefined'){
			data[jsRegisterFault.recaptcha.field] = $scope.formData.recaptchaResponse;
		}
		for (var i in $scope.formParams.fields) {
			if ($scope.formParams.fields[i].active) {
				if (i === 'address') {
					data[i] = $scope.formData[i];
					data.address_id = $scope.formData.address_id;
					data.house = $scope.formData.house;
					data.appartment = $scope.formData.appartment;
				}
				/*else if(i === 'photo'){
				 data.photo = $scope.formData.files;
				 }*/
				else if (i === 'phone') {
					data.phone = '+370' + $scope.formData.phone;
				} else {
					data[i] = $scope.formData[i];
				}
			}
		}
		if(typeof($scope.formData.itampos_kokybes_text)!=='undefined'){
			data.itampos_kokybes_text = $scope.formData.itampos_kokybes_text;
		}
		data.category = $scope.formData.category;
		return data;
	}

	$scope.onLastAnswerRender = function () {
		$scope.allAnswersRendered = true;
		$scope.$apply();
	};

	$scope.init = function (){
		$scope.embedTid = '';
		if(typeof(searchObj.forma)!=='undefined'){
			$scope.setDisplayStatus(1,searchObj.forma);
			if(searchObj.forma ==='svyruojaitampa'){
				$scope.questions = $scope.questions_svyruoja;
			}
			else if(searchObj.forma ==='elektrosskaitiklio'){
				$scope.questions = $scope.questions_el_saitiklio;
			}

			if(searchObj.forma ==='neraelektros'){
				$scope.embedTid = 4;
			}
			if(searchObj.forma ==='nerafazes'){
				$scope.embedTid = 5;
			}
		}

		if(typeof(searchObj.klausimas)!=='undefined'){
			let qlen = searchObj.klausimas.length;
			if(parseInt(qlen)>0){
				var question = $scope.questions[0];
				for(let i in searchObj.klausimas){
					var answers = [];
					if(typeof(question.answers)!=='undefined'){
						answers = question.answers.filter((item) => {
							return parseInt(item.question_id)===parseInt(searchObj.klausimas[i]);
						});
//						console.log(answers)
						if(typeof(answers[0])!=='undefined'){
//							console.log(searchObj.cat)
							if(answers.length>1 && typeof(searchObj.kategorija) !== 'undefined'){
									answers = question.answers.filter((item) => {
										let kategorija;
										if(searchObj.forma ==='svyruojaitampa'){
											kategorija = 'svyruojaitampa_0';
											if(searchObj.kategorija === '1'){
												kategorija = 'svyruojaitampa_1';
											}
										}
										if(searchObj.forma ==='elektrosskaitiklio'){
											kategorija = 'elektrosskaitiklio_0';
											if(searchObj.kategorija === '1'){
												kategorija = 'elektrosskaitiklio_1';
											}
										}

									return (!item.category || item.category===kategorija);
								});
							}
							$scope.getCurrentQuestions(answers[0]);
						}
					}

					let q = $filter('filter')($scope.questions, {id: parseInt(searchObj.klausimas[i])}, true);
					if(typeof(q[0])!=='undefined'){
						question = q[0];
					}

				}
			}
		}
	};

	$scope.init();

	}]).directive('onFinishRender', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			if (scope.$last === true) {
				element.ready(function () {
					scope.onLastAnswerRender();
				});
			}
		}
	};
}).directive('phonemask', function () {
	return {
		require: 'ngModel',
		link: function (scope, elem, attrs, ngModelCtrl) {
			scope.$watch(attrs.ngModel, function () {
				phone_pattern();
			});
		}
	};
});

EwSiteApp.directive('embedIframe', ["$sce", function($sce) {
	return {
	  restrict: 'E',
	  scope: {
		  type: '=',
		  tid: '='
	  },
	  replace: true,
	  link: function(scope, element, attrs) {
		function updateSrc() {
			if (typeof(scope.tid) !== 'undefined' && !isNaN(scope.tid) && scope.tid !== '' && typeof(scope.type) !== 'undefined' && scope.type !== '') {
				scope.src = $sce.trustAsResourceUrl(
					jsRegisterFault.embed_ranking_url.replace(/__TYPE__/, scope.type).replace(/__TID__/, scope.tid)
				);
			} else {
				scope.src = '';
			}
			scope.showFrame = (scope.src !== '');
		}
		scope.$watchGroup(['type', 'tid'], function(newValues, oldValues) {
			updateSrc();
		});

		updateSrc();
	  },
	  template: '<div><iframe style="width: 100%; height: 481px" ng-if="showFrame" src="{{src}}"></iframe></div>'
	};

}]);
